import { Skeleton } from "@/ui-kit";

export const LoadingState = () => {
  return (
    <div className="notification">
      <div className="notification-source">
        <Skeleton
          className="notification-skeleton"
          width="2rem"
          height="2rem"
          shape="round"
        />
      </div>
      <div className="notification-details">
        <Skeleton
          className="notification-skeleton"
          width="12.5rem"
          height="1.125rem"
        />
        <Skeleton
          className="notification-skeleton"
          width="6.25rem"
          height="0.9375rem"
        />
      </div>
    </div>
  );
};
